// Central, reversible site-stage settings.
// Set publicPricingEnabled to true to restore FounderStrip, PlansSection,
// the provider tier grid, and Plans/Fees navigation links.
// (Also re-add /fees to public/sitemap.xml when re-enabling.)
export const siteStage = {
  publicPricingEnabled: false,
  appUrl: 'https://app.resiax.com/',
  // Secure handoff LIVE: opaque single-use token only — no personal data in URLs.
  opaqueHandoffEnabled: true,
  pilotStartUrl: 'https://app.resiax.com/pilot/start',
};
